import React from "react";
import SideBar from "./SideBar/SideBar";
import NavBar from "./NavBar/NavBar";
import { Outlet } from "react-router-dom";


const MainLayout = () => {


    return (
        <>
            <NavBar />
            <SideBar />
            <main id="main" className="main">
                <section className="section dashboard">

                    <Outlet />
                </section>
            </main>

        </>
    )
}


export default MainLayout